import React, { Component } from 'react';
import v from 'vudu';
import { styles as s, classes as c, colors, format as f, breakpoints } from 'stylesheet';
import Text from 'components/Text';
import facebookIcon from 'assets/homeView/icon-facebook.svg';
import twitterIcon from 'assets/homeView/icon-twitter.svg';
import dribbleIcon from 'assets/homeView/icon-dribble.svg';
import Frame from 'components/svgs/Frame';

const localClasses = v({
  footerWrapper: {
    padding: '4rem 0',
    backgroundImage: 'linear-gradient(-45deg, #003045 0%, #060A35 100%)',
  },
  footerLarge: {
    display: 'none',
    [breakpoints.sm]: {
      display: 'block',
    }
  },
  footerSmall: {
    [breakpoints.sm]: {
      display: 'none',
    }
  },
  footerEndLarge: {
    padding: '4rem 0',
    '@composes': [s.flex],
    justifyContent: 'space-between'
  },
  footerEndSmall: {
    padding: '4rem 0',
    '@composes': [
      s.flex,
      s.flexColumn,
    ],
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerSet: {
    display: 'flex',
    alignItems: 'center'
  }
});

export default class Footer extends Component {
  render() {
    return (
      <div className={localClasses.footerWrapper}>
        <div className={c.row}>
          <div className={localClasses.footerLarge}>
            <div className="homepage-footer-columns-wrapper">
            <div className="homepage-footer-columns-container">
              <div className="homepage-footer-column-container">
                <div className="homepage-footer-column-title">PRODUCT</div>
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-small" />
                <div id="footer-enterprise" className="homepage-footer-column-link">Enterprise</div>
                <div id="footer-features" className="homepage-footer-column-link">Features</div>
                <div id="footer-iphone" className="homepage-footer-column-link">iPhone App</div>
                <div id="footer-pricing" className="homepage-footer-column-link">Pricing</div>
                <div id="footer-customers" className="homepage-footer-column-link">Customers</div>
              </div>
              <div className="homepage-footer-column-container integrations">
                <div className="homepage-footer-column-title"><a href="/integrations">INTEGRATIONS</a></div>
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-small" />
                <div id="footer-premiere" className="homepage-footer-column-link">Premiere Pro</div>
                <div id="footer-after-effects" className="homepage-footer-column-link">After Effects</div>
                <div id="footer-fcpx" className="homepage-footer-column-link">Final Cut Pro</div>
                <div id="footer-slack" className="homepage-footer-column-link">Slack</div>
              </div>
              <div className="homepage-footer-column-container company">
                <div className="homepage-footer-column-title">COMPANY</div>
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-small" />
                {/* <div class='homepage-footer-column-link'><a href="#">About</a></div> */}
                <div id="footer-careers" className="homepage-footer-column-link">Careers</div>
                <div id="footer-blog" className="homepage-footer-column-link">Blog</div>
                <div id="footer-swag-store" className="homepage-footer-column-link">Swag Store</div>
              </div>
              <div className="homepage-footer-column-container support">
                <div className="homepage-footer-column-title">SUPPORT</div>
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-small" />
                <div id="footer-support" className="homepage-footer-column-link">Support</div>
                <div id="footer-contact" className="homepage-footer-column-link">Contact Us</div>
                <div id="footer-status-page" className="homepage-footer-column-link">Status Page</div>
              </div>
            </div>
              <div className="homepage-footer-buttons-container">
                <div className="homepage-footer-button-border" />
                  <div id="footer-signin" className="button homepage-footer-sign-in-button">SIGN IN</div>
                  <div id="footer-signup" className="button homepage-footer-sign-up-button"><span>SIGN UP</span></div>
                </div>
              </div>

              <div className={f(c.col12, c.mxAuto, localClasses.footerEndLarge)}>
                <div className={localClasses.footerSet}>
                  <Text classes={c.pr2} variant={'p'}>{'Frame.io, Inc.'}</Text>
                  <Text classes={c.pr2} variant={'p'}>{'Terms'}</Text>
                  <Text classes={c.pr2} variant={'p'}>{'Privacy'}</Text>
                </div>
                <div className={localClasses.footerSet}><Frame /></div>
                <div className={localClasses.footerSet}>
                  <a href="https://www.facebook.com/frameioapp" target='_blank'>
                    <img src={facebookIcon} style={{ marginRight: '14px' }} />
                  </a>
                  <a href="https://twitter.com/Frame_io" target='_blank'>
                    <img src={twitterIcon} style={{ marginRight: '14px' }} />
                  </a>
                  <a href="https://dribbble.com/frameio" target='_blank'>
                    <img src={dribbleIcon} />
                  </a>
                </div>
              </div>
          </div>

          <div className={localClasses.footerSmall}>
            <div className="homepage-mobile-footer-columns-wrapper">
              <div className="homepage-mobile-footer-columns-container">
                <div className="homepage-mobile-footer-column-wrapper">
                  <div className="homepage-mobile-footer-column-container">
                    <div className="homepage-mobile-footer-column-title">PRODUCT</div>
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-small" />
                    <div id="footer-mobile-enterprise" className="homepage-mobile-footer-column-link">Enterprise</div>
                    <div id="footer-mobile-features" className="homepage-mobile-footer-column-link">Features</div>
                    <div id="footer-mobile-iphone" className="homepage-mobile-footer-column-link">iPhone App</div>
                    <div id="footer-mobile-pricing" className="homepage-mobile-footer-column-link">Pricing</div>
                    <div id="footer-mobile-customers" className="homepage-mobile-footer-column-link">Customers</div>
                  </div>
                  <div className="homepage-mobile-footer-column-container integrations">
                    <div className="homepage-mobile-footer-column-title"><a href="/integrations">INTEGRATIONS</a></div>
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-small" />
                    <div id="footer-mobile-premiere" className="homepage-mobile-footer-column-link">Premiere Pro</div>
                    <div id="footer-mobile-after-effects" className="homepage-mobile-footer-column-link">After Effects</div>
                    <div id="footer-mobile-fcpx" className="homepage-mobile-footer-column-link">Final Cut Pro</div>
                    <div id="footer-mobile-slack" className="homepage-mobile-footer-column-link">Slack</div>
                  </div>
                </div>
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-small" />
                <div className="vertical-padding-small" />
                <div className="vertical-padding-small" />
                <div className="vertical-padding-small" />
                <div className="homepage-mobile-footer-column-wrapper">
                  <div className="homepage-mobile-footer-column-container company">
                    <div className="homepage-mobile-footer-column-title">COMPANY</div>
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-small"  />
                    {/* <div class='homepage-mobile-footer-column-link'><a href="#">About</a></div> */}
                    <div id="footer-mobile-careers" className="homepage-mobile-footer-column-link">Careers</div>
                    <div id="footer-mobile-blog" className="homepage-mobile-footer-column-link">Blog</div>
                    <div id="footer-mobile-swag-store" className="homepage-mobile-footer-column-link">Swag Store</div>
                  </div>
                  <div className="homepage-mobile-footer-column-container support">
                    <div className="homepage-mobile-footer-column-title">SUPPORT</div>
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-medium" />
                    <div className="vertical-padding-small"  />
                    <div id="footer-mobile-support" className="homepage-mobile-footer-column-link">Support</div>
                    <div id="footer-mobile-contact" className="homepage-mobile-footer-column-link">Contact Us</div>
                    <div id="footer-mobile-status-page" className="homepage-mobile-footer-column-link">Status Page</div>
                  </div>
                </div>
              </div>
              <div className="vertical-padding-large"  />
              <div className="vertical-padding-medium" />
              <div className="vertical-padding-medium" />
              <div className="vertical-padding-medium" />
              <div className="vertical-padding-medium" />
              <div className="vertical-padding-medium" />
              <div className="vertical-padding-medium" />
              <div className="vertical-padding-small"  />
              <div className="vertical-padding-small"  />
              <div className="vertical-padding-small"  />
              <div className="homepage-mobile-footer-buttons-container">
                <div id="footer-mobile-signup" className="homepage-mobile-footer-signup-button-container">
                  <div className="homepage-mobile-footer-button-border" />
                  <div className="homepage-mobile-footer-sign-up-button button-footer"><span>SIGN UP</span></div>
                </div>
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div className="vertical-padding-medium" />
                <div id="footer-mobile-signin" className="homepage-mobile-footer-sign-in-button button-footer">SIGN IN</div>
              </div>
            </div>

            <div className={f(c.col12, c.mxAuto, localClasses.footerEndSmall)}>
              <div className={f(localClasses.footerSet, c.mb4)}>
                <a href="https://www.facebook.com/frameioapp" target='_blank'>
                  <img src={facebookIcon} style={{ marginRight: '14px' }} />
                </a>
                <a href="https://twitter.com/Frame_io" target='_blank'>
                  <img src={twitterIcon} style={{ marginRight: '14px' }} />
                </a>
                <a href="https://dribbble.com/frameio" target='_blank'>
                  <img src={dribbleIcon} />
                </a>
              </div>
              <div className={f(localClasses.footerSet, c.mb4)}>
                <Text classes={c.pr2} variant={'p'}>{'Frame.io, Inc.'}</Text>
                <Text classes={c.pr2} variant={'p'}>{'Terms'}</Text>
                <Text classes={c.pr2} variant={'p'}>{'Privacy'}</Text>
              </div>
              <div className={localClasses.footerSet}><Frame /></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js